import React ,{useContext,useEffect,useState} from 'react';
import { EnvironmentContext } from '../index';
import { Link, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import logo from '../img/signuluone-lockup.png';
import smallLogo from '../img/signuluone-lockup.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import $ from 'jquery';
 
function Header() {
  const  env = useContext(EnvironmentContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 768); 
    };

    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
    };
  }, []);

 
  const handleMouseEnter = () => {
    if (!isMobile && !dropdownOpen) {
      setDropdownOpen(true); 
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setDropdownOpen(false); 
    }
  };
  const handleDropdownClick = () => {
    if (isMobile || dropdownOpen) {
      setDropdownOpen((prevState) => !prevState);
    } else if (!isMobile && !dropdownOpen) {
      setDropdownOpen(true);
    }
  };

  useEffect(() => {
    const navLinks = document.querySelectorAll('.nav-link');
    const navDropDown = document.querySelector('.nav_dropDown');

    navLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (navDropDown) {
          navDropDown.style.display = navDropDown.style.display === 'none' || !navDropDown.style.display ? 'block' : 'none';
        }
      });
    });

    return () => {
      // Cleanup: remove event listeners on component unmount
      navLinks.forEach((link) => {
        link.removeEventListener('click', () => {
          if (navDropDown) {
            navDropDown.style.display = 'block';
          }
        });
      });
    };
  }, []);
  useEffect(() => {
    AOS.init({
      once: true,
      disable: function () {
        var maxWidth = 800;
        return window.innerWidth < maxWidth;
      },
    });

    $(window).scroll(function () {
      if ($(this).scrollTop() > 50) {
        $('body').addClass('sticky');
      } else {
        $('body').removeClass('sticky');
      }
    });

    $('.nav-link').click(function () {
      $('.nav_dropDown').slideToggle(600);
    });

    $('.counter').each(function () {
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text()
      }, {
        duration: 4000,
        easing: 'swing',
        step: function (now) {
          $(this).text(Math.ceil(now));
        }
      });
    });

    (function () {
      var words = ['Efficient', 'Secure', 'Trustworthy'], i = 0;
      setInterval(function () {
        $('#changingword').fadeOut(function () {
          $(this).html(words[i = (i + 1) % words.length]).fadeIn();
        });
      }, 3000);
    })();

    function dataWord() {
      $("[data-words]").attr("data-words", function (i, d) {
        var $self = $(this),
          $words = d.split("|"),
          tot = $words.length,
          c = 0;

        for (var i = 0; i < tot; i++) $self.append($('<span/>', { text: $words[i] }));
        $words = $self.find("span").hide();

        (function loop() {
          $self.animate({ width: $words.eq(c).width() });
          $words.stop().fadeOut().eq(c).fadeIn().delay(2000).show(0, loop);
          c = ++c % tot;
        }());
      });
    }

    $(window).on('load', dataWord);
  }, []);
  return (
    <div className='body'>
    <header className="site-header">
      <nav className="navbar navbar-expand-lg navbar-light navbar-signulu">
        <div className="container container-xxl container-xl container-lg">
          <Link
            className="navbar-brand d-inline-flex flex-column align-items-center lh-1"
            to="https://www.signuluone.com/"
            style={{ gap: 0 }}
          >
            <img src={logo} alt="SignuluOne" className="brand-wordmark" style={{ height: '38px', width: 'auto' }} />
            <span
              style={{
                fontSize: '0.7rem',
                fontWeight: 800,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'rgb(91, 110, 246)',
              }}
            >
              SIGNULU
            </span>
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-end customsidebaroffsets" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header">
              <Link className="navbar-brand" to="/">
                <img src={smallLogo} alt="Small Logo" />
              </Link>
              <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body custom-offcanvas-body" id="nav-menu">
              <ul className="navbar-nav justify-content-center flex-grow-1 pe-3">
                <li className="nav-item">
                  <NavLink className="nav-link" end aria-current="page"
                  to="/"
                  onClick={(e) => {
                    if (window.location.pathname === '/') {
                      e.preventDefault();
                      window.location.href = '/';
                    }
                  }}
                  >Home</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" aria-current="page"
                  to="/about"
                  onClick={(e) => {
                    if (window.location.pathname === '/about') {
                      e.preventDefault();
                      window.location.href = '/about';
                    }
                  }}
                  >About</NavLink>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-link" href="#">
                    Industry Solutions <img src={downArrow} alt="Down Arrow" />
                  </a> */}
                   <li
                    className="nav-item"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <a
                      className="nav-link"
                      onClick={handleDropdownClick}
                      style={{ cursor: 'pointer' }}
                    >
                      Industry Solutions <i className="bi bi-chevron-down"></i>
                    </a>
                    {dropdownOpen && (
                  <div className="nav_dropDown mega-menu mega-menu-wide" style={{display:"block" }}>
                    <div className="mega-menu-heading">Solutions by Industry</div>
                    <div className="mega-menu-grid">
                      <Link className="mega-link" to="/manufacturing"
                       onClick={(e) => {
                        if (window.location.pathname === '/manufacturing') {
                          e.preventDefault();
                          window.location.href = '/manufacturing';
                        }
                      }}
                      >
                        <i className="bi bi-gear"></i>
                        <span>
                          <span className="mega-title">Manufacturing</span>
                          <span className="mega-desc">Streamline approvals across your supply chain.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/banking-financial-services"
                      onClick={(e) => {
                        if (window.location.pathname === '/banking-financial-services') {
                          e.preventDefault();
                          window.location.href = '/banking-financial-services';
                        }
                      }}
                      >
                        <i className="bi bi-bank"></i>
                        <span>
                          <span className="mega-title">Banking and Financial Services</span>
                          <span className="mega-desc">Secure, compliant signing for financial workflows.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/professional-services"
                       onClick={(e) => {
                        if (window.location.pathname === '/professional-services') {
                          e.preventDefault();
                          window.location.href = '/professional-services';
                        }
                      }}
                      >
                        <i className="bi bi-briefcase"></i>
                        <span>
                          <span className="mega-title">Professional Services</span>
                          <span className="mega-desc">Close engagements and contracts faster.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/real-estate"
                      onClick={(e) => {
                        if (window.location.pathname === '/real-estate') {
                          e.preventDefault();
                          window.location.href = '/real-estate';
                        }
                      }}
                      >
                        <i className="bi bi-house-door"></i>
                        <span>
                          <span className="mega-title">Real Estate</span>
                          <span className="mega-desc">Sign leases and closing documents digitally.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/healthcare"
                       onClick={(e) => {
                        if (window.location.pathname === '/healthcare') {
                          e.preventDefault();
                          window.location.href = '/healthcare';
                        }
                      }}
                      >
                        <i className="bi bi-heart-pulse"></i>
                        <span>
                          <span className="mega-title">Healthcare</span>
                          <span className="mega-desc">Fast, secure signing for patient documentation.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/law"
                      onClick={(e) => {
                        if (window.location.pathname === '/law') {
                          e.preventDefault();
                          window.location.href = '/law';
                        }
                      }}
                      >
                        <i className="bi bi-shield-check"></i>
                        <span>
                          <span className="mega-title">Law</span>
                          <span className="mega-desc">Legally binding signatures for contracts and filings.</span>
                        </span>
                      </Link>
                      <Link className="mega-link" to="/it"
                      onClick={(e) => {
                        if (window.location.pathname === '/it') {
                          e.preventDefault();
                          window.location.href = '/it';
                        }
                      }}
                      >
                        <i className="bi bi-cpu"></i>
                        <span>
                          <span className="mega-title">IT</span>
                          <span className="mega-desc">Fast, secure approvals for technology teams.</span>
                        </span>
                      </Link>
                    </div>
                  </div>)}
                </li>
                <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/pricing"
                  onClick={(e) => {
                    if (window.location.pathname === '/pricing') {
                      e.preventDefault();
                      window.location.href = '/pricing';
                    }
                  }}
                >
                  Pricing
                </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link"
                  to="/blog"
                  onClick={(e) => {
                    if (window.location.pathname === '/blog') {
                      e.preventDefault();
                      window.location.href = '/blog';
                    }
                  }}
                  >Blog</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link"
                 to="/contact"
                  onClick={(e) => {
                    if (window.location.pathname === '/contact') {
                      e.preventDefault();
                      window.location.href = '/contact';
                    }
                  }}
                  >Contact</NavLink>
                </li>
              </ul>
              <div className="d-flex start-trl align-items-center">
                <a className="btn-navy" href={`${env}`}>Login</a>
                <a className="btn-accent" href={`${env}/account/register`}>Start Trial</a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    </div>
  );
}

export default Header;
